<template>
  <div class="supply">
    <div class="edit_supply_warp">
      <van-field
        class="edit_supply_textarea"
        v-model="content"
        type="textarea"
        placeholder="请输入供需内容"
        @input="fieldChange"
        maxlength="200"
        rows="4"
        show-word-limit
      />
      <div class="uploading_wrap">
        <!-- <div class="img_block" v-for="(item,index) in imgList" :key="index">
          <div class="img_wrap" @click="viewImg(item)">
            <img :src="item + oMyBus" />
          </div>
          <van-icon name="clear" @click="clearImg(index)" />
        </div>
        <div class="img_uploading" @click="setImg" v-if="imgList.length<5">
          <van-icon name="plus" class="van-uploader__upload-icon" style="color:#666" />
        </div> -->
        <van-uploader
            v-model="fileList"
            multiple
            :max-count="5"
            :before-read="beforeRead"
            :after-read="afterRead"
        />
      </div>
      <span style="color:#bfbfbf;">最多可上传5张图片</span>
      <div class="btn-bg">
        <div class="btn" @click="submitRelease">
          <span>发布</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  name: "editSupply",
  components: {},
  data() {
    return {
      content: "",
      imgList: [],
      isNotPreview: false,
      content: "",
      content1: "",
      relepase: [],
      themeIds: [],
      edittalk: false, //默认是提交讨论
      talkId: "",
      topicId: "",
      isMy: false,
      tx_show: true,
      fileList: [],
      Upimg:[], // 上传的图片
    };
  },
  computed: {},
  methods: {
    ...mapActions({
      goTopicsearch: "linkTo/Linktopicsearch",
      TalkRelease: "topicSupply/TalkRelease",
      getTopicOne: "topicSupply/getTopicOne",
      TalkDetail: "topicSupply/TalkDetail",
      EditTalk: "topicSupply/EditTalk",
    }),
    getTopicId(topicId) {
      this.topicId = topicId;
      this.newRelease();
    },
    async newRelease() {
      this.edittalk = false;
      //获取话题列表
      let topicList = await this.getTopicOne(this.topicId);
      this.relepase.push(topicList.data);
      this.relepase = this.deteleObject(this.relepase);
      wx.setStorageSync("relepase", this.relepase);
    },
    deteleObject(obj) {
      let uniques = [];
      let stringify = {};
      for (let i = 0; i < obj.length; i++) {
        let keys = Object.keys(obj[i]);
        keys.sort(function (a, b) {
          return Number(a) - Number(b);
        });
        let str = "";
        for (let j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j]);
          str += JSON.stringify(obj[i][keys[j]]);
        }
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i]);
          stringify[str] = true;
        }
      }
      uniques = uniques;
      return uniques;
    },
    fieldChange(e) {
      this.content = e.mp.detail;
    },
    async editTalk() {
      let opt = {
        talkId: this.talkId,
        memberId: this.userInfo.id,
      };
      let data = await this.TalkDetail(opt);
      this.talkDetail = data;
      this.content = data.content;
      this.relepase = data.themes[0];
      if (this.talkDetail.imgUrls) {
        this.imgList = data.imgUrls.split(";");
      }
    },
    // 发布话题-讨论
    async submitRelease() {
      if (this.relepase) {
        this.relepase.forEach((v) => {
          this.themeIds.push(v.id);
        });
      }
      console.log(this.themeIds, " this.themeIds");
      if (!this.content) {
        wx.showToast({
          title: "请输入话题内容",
          icon: "none",
          duration: 1000,
        });
        return;
      }
      if (!this.themeIds || this.themeIds.length == 0) {
        wx.showToast({
          title: "请至少选择一个话题",
          icon: "none",
          duration: 1000,
        });
        return;
      }
      if (!this.edittalk) {
        let opt = {
          themeIds: this.themeIds,
          memberId: this.userInfo.id,
          content: this.content,
          imgUrls: this.imgList.join(";"),
          auditState: 0,
          orgin: this.isMy ? this.exhibitionInfo.name : "平台",
        };
        let data = await this.TalkRelease(opt);
        if (data && data.result) {
          wx.showToast({ title: "提交成功" });
          wx.setStorageSync("relepase", "") || [];
          setTimeout(() => {
            wx.navigateBack({
              delta: 1,
            });
          }, 2000);
        } else {
          wx.showToast({
            title: "提交失败",
            icon: "none",
            duration: 1000,
          });
        }
      } else {
        let opt = {
          auditState: 0,
          themeIds: this.themeIds,
          memberId: this.userInfo.id,
          content: this.content,
          id: this.talkId,
        };
        if (this.imgList.length) {
          opt.imgUrls = this.imgList.join(";");
        }
        let data = await this.EditTalk(opt);
        if (data && data.result) {
          wx.showToast({ title: "提交成功" });
          setTimeout(() => {
            wx.navigateBack({
              delta: 1,
            });
          }, 2000);
        } else {
          wx.showToast({
            title: "提交失败",
            icon: "none",
            duration: 1000,
          });
        }
      }
    },
    gotopicsearch() {
      if (this.relepase.length < 3) {
        this.$refs["search"].open();
        this.tx_show = false;
      } else {
        wx.showToast({
          title: "最多选择三个话题",
          icon: "none",
          duration: 1000,
        });
      }
    },
    opentx_show() {
      this.tx_show = true;
    },
    delete_relepase(index) {
      console.log(index, "index");
      this.relepase.splice(index, 1);
      wx.setStorageSync("relepase", this.relepase);
    },
    viewImg(e) {
      this.isNotPreview = true;
      let imgL = this.imgList;
      imgL = imgL.map((c) => {
        return (c += this.oPotoView);
      });
      wx.previewImage({
        current: e + this.oPotoView, // 当前显示图片的http链接
        urls: imgL, // 需要预览的图片http链接列表
      });
    },
    //删除图片
    clearImg(index) {
      this.imgList.splice(index, 1);
    },
    //上传图片
    async setImg() {
      console.log("aaaaaas");
      this.isNotPreview = true;
      if (this.imgList.length > 5) {
        wx.showToast({
          title: "最多传5张图片",
          icon: "none",
          duration: 1000,
        });
        return;
      }
      let that = this;
      wx.chooseImage({
        count: 5, // 默认9(图片的数量)
        sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
        success: function (res) {
          const tempFilePaths = res.tempFilePaths; // tempFilePath可以作为img标签的src属性显示图片
          console.log(res.tempFilePaths, "ressssssssssss");
          wx.showLoading({
            title: "正在上传...",
          });
          for (let i = 0; i < tempFilePaths.length; i++) {
            wx.uploadFile({
              url: "https://online-api.zhanshangxiu.com/api/v1/file",
              filePath: tempFilePaths[i],
              name: "file",
              formData: {
                file: "img",
              },
              header: {
                "Content-Type": "multipart/form-data",
              },
              success(res) {
                var data = JSON.parse(res.data);
                if (data.result && data.data.length > 0) {
                  wx.hideLoading();
                  if (that.imgList.length < 5) {
                    that.imgList.push(data.data[0]);
                  }
                }
              },
              fail(res) {
                wx.showToast({
                  title: "上传失败！",
                  icon: "none",
                  duration: 1000,
                });
              },
            });
          }
        },
      });
    },

    // 返回布尔值
    beforeRead(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJPG) {
            this.$service.showDialog(this, this.$t('hall.trade.img1'), false);
            return false;
        }
        console.log(file);
        if(file.size > 1024 * 4000){ //图片不能超过4M 
            this.$service.showDialog(this, this.$t('hall.trade.img2'), false)
            return false;
        }
        return true;
    },
    // 上传完成，上传至服务器
    afterRead(file){
        console.log(file,'上传完成');
        // let data = new FormData();
        // data.append('multfile', file.file);
        // data.append('operaType',null);
        // this.$dialog.loading.open();
        // this.$http.post('/api/upload/images',data)
        //             .then(res=>{
        //                 this.$dialog.loading.close();
        //                 this.Upimg.push(res.data.Data.imgUrls[0])
        //                 this.show=false;
        //             }).catch(err=>{
        //                 this.$service.showDialog(this, this.$t('hall.trade.img3'), false)
        //             })
    },

  },
};
</script>

<style lang="scss" scoped>
.supply {
  width: 100%;
  background-color: #f5f5f5;
  min-height: 100vh;
}
.edit_supply_warp {
  padding: 0 0.24rem 0.24rem;
  color: #fff;
  background: #fff;
    .van-cell {
      padding: .25rem .2rem .1rem;
      margin-bottom: .5rem;
      border-radius: 3px;
      background: #fff;
      overflow-y:initial;
      &::after {
        display: none;
      }
    .van-field__input {
      min-height: 1.3rem;
      color: #333;
    }
    .van-field__word-limit {
      color: #bfbfbf;
    }
  }
  .uploading_wrap {
    display: flex;
    margin-bottom: 0.2rem;
    flex-wrap: wrap;
    .img_block {
      margin-right: 0.2rem;
      position: relative;
      &:nth-child(3) {
        margin-right: 0;
      }
      .img_wrap {
        width: 2.14rem;
        height: 2.14rem;
        border-radius: 1px;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          // object-fit: cover;
        }
      }
      .van-icon {
        background: transparent;
        font-size: 0.35rem;
        top: -0.12rem;
        right: -0.12rem;
        color: #fff;
      }
    }
      .img_uploading{
        .van-uploader__upload-icon {
          font-size: .3rem;
        }
        margin: 0;
        border: 1px  #cccccc dashed;
        display: flex;
        justify-content: center;
        width: 2.14rem;
        height: 2.14rem;
        background-color: #f2f2f2;
        border-radius: .1rem;

      }
      .van-icon-clear {
        font-size: .3rem;
        position: absolute;
        top: 0;
        right: 0;
        font-size: .3rem;
        margin-right: -.15rem;
        margin-top: -.15rem;
        color: #666;
      }
  }
}
.btn-bg {
  position: fixed;
  background-color: #fff;
  bottom: 0;
  left: 0;
  right: 0;
  height: 0.98rem;
  width: 100%;
  text-align: center;
}
.btn {
  width: 6.5rem;
  height: 0.78rem;
  background-color: #1890ff;
  border-radius: 0.37rem;
  border: solid 2px #1890ff;
  margin: 0 auto;
  margin-top: 0.1rem;
  span{
      color: #fff;
      font-size: .3rem;
      line-height:.78rem;
  }
}
</style>
